import { motion } from '@eversports/react-components/design-tokens/motion'
import React from 'react'
import BackButton from '../components/BackButton'

const ReviewInformation: React.FC<React.PropsWithChildren<unknown>> = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ ease: 'easeInOut' }}
  >
    <BackButton />
  </motion.div>
)

export default ReviewInformation
